import request from '@/utils/request';
//优惠券列表
export function getOperateList(values) {
  return request('/activityGroup/queryPage', {
    method: 'POST',
    data: values,
  });
}
//暂停活动
export function activityGroupPause(values) {
  return request('/activityGroup/pause', {
    method: 'POST',
    data: values,
  });
}

// 终止活动
export function activityGroupTerminate(values) {
  return request('/activityGroup/terminate', {
    method: 'POST',
    data: values,
  });
}
// 重启活动
export function activityGroupRestart(values) {
  return request('/activityGroup/restart', {
    method: 'POST',
    data: values,
  });
}
// 审核
export function activityGroupApprove(values) {
  return request('/activityGroup/approve', {
    method: 'POST',
    data: values,
  });
}
